// extracted by mini-css-extract-plugin
export default {"container":"NoDataLabel_container__T3-7U"};